import {
  EmploymentType,
  IncomeType,
  PensionersMaritalStatus,
  Region,
  ResidencyStatus,
  TaxFileNumberExemptionType,
  TaxScaleType,
} from '$constants'
import { XeroEmployee } from './xeroEmployee'
import { PayrollEmployee } from './payrollEmployee'
import { Nullable } from '$models'

export interface XeroAuEmployee extends XeroEmployee {
  region?: Region
  taxFileNumber: Nullable<string>
  hasTaxFileNumberExemption?: boolean
  taxFileNumberExemptionType?: Nullable<TaxFileNumberExemptionType>
  residencyStatus?: Nullable<ResidencyStatus>
  incomeType?: Nullable<IncomeType>
  taxScaleType?: Nullable<TaxScaleType>
  claimingTaxFreeThreshold?: boolean
  claimingZoneOverseasOrInvalid?: boolean
  annualOffsetAmountClaimed?: Nullable<number>
  payeesWorkingCondition?: Nullable<string>
  hasStudyLoanOrFinancialDebt?: boolean
  pensionersMaritalStatus?: Nullable<PensionersMaritalStatus>
  superFundId?: Nullable<string>
  notEligibleForSuperFund?: boolean
  superFundNameOrUsi?: Nullable<string>
  superFundSelfManaged?: boolean
  superFundMemberNumber?: Nullable<string>
  superFundABN?: Nullable<string>
  superFundESA?: Nullable<string>
  superFundAccountName?: Nullable<string>
  superFundAccountNumber?: Nullable<string>
  superFundBSB?: Nullable<string>
  calendarId: Nullable<string>
  ordinaryEarningsRateId: Nullable<string>
  employmentType: Nullable<EmploymentType>
  bsb?: Nullable<string>
  statementText?: Nullable<string>
}

// Function to apply transformations to XeroAuEmployee object on get
export const transformXeroAuEmployeeAuOnGet = (
  payrollEmployee: PayrollEmployee
): XeroAuEmployee => {
  const transformedPayrollEmployee: XeroAuEmployee =
    payrollEmployee as XeroAuEmployee

  //This is a workaround because the API is returning null for booleans if they are not set
  transformedPayrollEmployee.hasTaxFileNumberExemption =
    transformedPayrollEmployee.hasTaxFileNumberExemption ?? false
  transformedPayrollEmployee.claimingTaxFreeThreshold =
    transformedPayrollEmployee.claimingTaxFreeThreshold ?? false
  transformedPayrollEmployee.claimingZoneOverseasOrInvalid =
    transformedPayrollEmployee.claimingZoneOverseasOrInvalid ?? false
  transformedPayrollEmployee.hasStudyLoanOrFinancialDebt =
    transformedPayrollEmployee.hasStudyLoanOrFinancialDebt ?? false
  transformedPayrollEmployee.superFundSelfManaged =
    transformedPayrollEmployee.superFundSelfManaged ?? false
  transformedPayrollEmployee.notEligibleForSuperFund =
    transformedPayrollEmployee.notEligibleForSuperFund ?? false

  return transformedPayrollEmployee
}
